// src/AppContent.jsx
import React, { Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n/i18n';
import DashboardPage from './pages/Dashboard';
import NotFoundPage from './pages/NotFound';
import IdentificationRoutes from './routes/identification';

export default function AppContent() {
  return (
    <I18nextProvider i18n={i18n}>
      <Suspense fallback={
        <div className="flex justify-center items-center min-h-screen bg-gray-100 dark:bg-gray-900">
          <div className="animate-spin rounded-full h-20 w-20 border-t-4 border-b-4 border-indigo-500"></div>
          <p className="ml-4 text-xl text-gray-700 dark:text-gray-300">
            Chargement des traductions...
          </p>
        </div>
      }>
        <Routes>
          <Route index element={<DashboardPage />} />
          <Route path="*" element={<NotFoundPage />} />
          
          <Route path="identification/*">
            {IdentificationRoutes}
          </Route>
        </Routes>
      </Suspense>
    </I18nextProvider>
  );
}
